import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.addresses,"items-per-page":10},scopedSlots:_vm._u([{key:"item.address1",fn:function({ item }){return [_vm._v(" "+_vm._s(_vm.generateAddress(item))+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }